import React from "react";
import {
  Box,
  Typography,
  Paper,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import waterDropBackground from "../Assets/eventclose.png";
import logo from "../Assets/OWW-Logo4.png"; // Assuming you have such an image, or replace with another asset

const ClosedRegistration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${waterDropBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={8}
          sx={{
            padding: { xs: 3, md: 6 },
            borderRadius: 4,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(10px)",
            textAlign: "center",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            boxShadow: "0 8px 32px rgba(31, 38, 135, 0.2)",
          }}
        >
          <Typography
            variant={isMobile ? "h4" : "h2"}
            component="h1"
            gutterBottom
            fontWeight="bold"
            sx={{
              color: "primary.main",
              marginBottom: 3,
            }}
          >
            Oman Water Week
          </Typography>

          <Typography
            variant={isMobile ? "h5" : "h4"}
            component="h2"
            gutterBottom
            sx={{ color: "text.primary" }}
          >
            Registration for Oman Water Week 2025 is closed
          </Typography>

          <Typography
            variant="h6"
            sx={{
              marginTop: 4,
              color: "text.secondary",
              fontWeight: "medium",
            }}
          >
            Stay tuned for 2026 updates!
          </Typography>

          <Box
            component="img"
            src={logo} // Replace with your actual logo path
            alt="Oman Water Week Logo"
            sx={{
              maxWidth: { xs: "150px", md: "200px" },
              margin: "2rem auto 1rem",
              opacity: 0.8,
            }}
          />
        </Paper>
      </Container>
    </Box>
  );
};

export default ClosedRegistration;
